<!--导航栏：负责转接前端的所有界面-->

<template>
  <div id="nav">
<!--    根据路由来进行一个展示，router-view相当于全局默认访问-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name:"App"
}
</script>
